// extracted by mini-css-extract-plugin
module.exports = {"root":"toggle_root__qatcM","variant-default":"toggle_variant-default__I8G4u","variant-white":"toggle_variant-white__jASxP","active":"toggle_active__D_are"};